import React from 'react';
import { SlidePage } from '../index';
import { BodyContainer } from '../styles';
import mapaOrientacionCarreras from '../imgs/mapa-orientacion-carreras_updated.png';

const VocationOneOrientacionDescriptionPage = ({ background, number }) => {
  return (
    <SlidePage number={number} background={background}>
      <BodyContainer>
        <div className='content'>
          <h1>2. Orientación Vocacional</h1>
          <p className='justified'>
            El Test Vocation Junior identifica tus intereses vocacionales en base a
            un modelo de 8 preferencias principales. Generalmente las personas
            tienden a preferir cierto tipo de actividades o entornos en los que
            se sentirían más cómodos/as en un futuro laboral, por sobre otros.
            Cada una de estas 8 áreas describen distintos tipos de preferencias
            vocacionales:
          </p>
          <div
            className='image-wrapper'
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <img
              src={mapaOrientacionCarreras}
              alt='mapa Orientación Vocacional'
              style={{ height: 500, marginBottom: -16, marginTop: -14 }}
            />
          </div>
          <p className='justified'>
            Hay personas que pueden tener intereses más definidos en un área
            particular, mientras que otras pueden presentar mayor variedad de
            intereses. En este modelo, algunas áreas están más relacionadas
            entre sí (por ejemplo, el área de{' '}
            <em>Soporte Social y Educación</em> se relaciona de forma más
            directa con el área de <em>Influencia y Personas</em>, y estará
            menos relacionada con intereses en el área de{' '}
            <em>Ciencias y Datos</em>). Sin embargo, una persona si puede tener
            intereses en áreas que se encuentran menos relacionadas. Por
            ejemplo, una persona puede mostrar preferencias en áreas como{' '}
            <em>Artes y Literatura</em> y al mismo tiempo cierto grado de
            interés en <em>Administración y Proyectos</em>.
          </p>
        </div>
      </BodyContainer>
    </SlidePage>
  );
};

export default VocationOneOrientacionDescriptionPage;
